import styled, { css } from 'styled-components';
import { ListVariant } from '../../_shared/types/trade';

const listViewFilter = css`
  grid-column: 1;
  grid-row: 2;
`;

const gridViewFilter = css`
  @media only screen and (max-width: 1749px) {
    position: fixed;
    left: 0;
    ${({ visible }) => !visible && 'display: none;'}
    z-index: 28;
    margin-top: -5px;
  }

  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.GRIDVIEW_DESKTOP_WM}) {
    grid-column: 1;
    grid-row: 1 / span 2;
  }
`;

export const StyledFilterContainer = styled.aside`
  width: 240px;
  margin-right: 24px;
  background: white;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  align-self: start;
  border-radius: 3px;
  position: sticky;
  top: ${props => props.top || 96}px;
  ${({ variant }) => variant === ListVariant.LIST && listViewFilter}
  ${({ variant }) => variant === ListVariant.GRID && gridViewFilter}
`;

export default {};
